import React from 'react'
import { Container, Typography } from '@mui/material'
import FormSubmissionContainer from './containers/FormSubmissionContainer'

const FormSubmissionPage: React.FC = () => {
    return (
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
            <Typography variant="h4" component="h1" gutterBottom>
                Form Submission
            </Typography>
            <FormSubmissionContainer />
        </Container>
    )
}

export default FormSubmissionPage 